module.exports = __webpack_public_path__ + "static/021-7d258b2a8827038488509917a5b6242b.jpg";